import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };

const getFirstBlockNotifications = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/notifications/first-block',
    headers,
    successCallback,
    errorCallback,
  );
};

const getSecondBlockNotifications = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/notifications/second-block',
    headers,
    successCallback,
    errorCallback,
  );
};

const NotificationsApi = {
  getFirstBlockNotifications,
  getSecondBlockNotifications,
};

export default NotificationsApi;



// WEBPACK FOOTER //
// ./src/apis/notifications.js